import numeral from 'numeral';

// ----------------------------------------------------------------------

// export function fCurrency(number) {
//   return numeral(number).format(Number.isInteger(number) ? '$0,0' : '$0,0.00');
// }

export function fCurrency(value) {
  // const v = e.currentTarget.value.replaceAll(',', '');
  return parseFloat(value).toFixed(3).replace(/\d(?=(\d{3})+\.)/g, '$&,');
};

export function fPercent(number) {
  return numeral(number / 100).format('0.0%');
}

export function fNumber(number) {
  return numeral(number).format();
}

export function fShortenNumber(number) {
  return numeral(number).format('0.00a').replace('.00', '');
}

export function fData(number) {
  return numeral(number).format('0.0 b');
}


export function removeTrailingZeros(num) {
  // Convert to string in fixed-point notation with enough decimals to keep precision
  let str = num.toString();

  // If no decimal point, just return the number as string
  if (!str.includes('.')) {
    return str;
  }

  // Remove trailing zeros
  str = str.replace(/(\.\d*?[1-9])0+$/g, '$1');

  // Remove trailing decimal if no digits after decimal
  str = str.replace(/\.0*$/, '');

  return str;
}
